export const roundArrow = () => (
  <svg width='21' height='21' viewBox='0 0 21 21' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path d='M20.125 3.5V8.75H14.875' stroke='#1F1F24' stroke-width='1.63447' stroke-linecap='round' stroke-linejoin='round' />
    <path
      d='M17.9291 13.1253C17.3604 14.7352 16.2837 16.1166 14.8615 17.0615C13.4393 18.0063 11.7485 18.4632 10.044 18.3635C8.33947 18.2638 6.71352 17.6128 5.41117 16.5086C4.10882 15.4044 3.20063 13.9068 2.82345 12.2416C2.44628 10.5763 2.62055 8.83355 3.32001 7.27594C4.01947 5.71834 5.20623 4.43026 6.70144 3.60582C8.19666 2.78137 9.91932 2.46522 11.6098 2.70501C13.3004 2.94479 14.8672 3.72753 16.0741 4.93526L20.1254 8.75026'
      stroke='#1F1F24'
      stroke-width='1.63447'
      stroke-linecap='round'
      stroke-linejoin='round'
    />
  </svg>
);
